// import React, { useEffect, useState } from "react";
// import { Api } from "../Api/Api";

// const TypeManagement = () => {
//   const [types, setTypes] = useState([]);
//   const [typeName, setTypeName] = useState("");
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     loadTypes();
//   }, []);

//   const loadTypes = async () => {
//     const res = await fetch(`${Api}customers/types/list.php`);
//     const data = await res.json();
//     setTypes(data.types || []);
//   };

//   const addType = async () => {
//     if (!typeName.trim()) return alert("Enter type name");

//     setLoading(true);
//     const res = await fetch(`${Api}customers/types/add.php`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ type_name: typeName }),
//     });
//     const data = await res.json();
//     setLoading(false);

//     if (data.status) {
//       setTypeName("");
//       loadTypes();
//     } else {
//       alert(data.message);
//     }
//   };

//   const toggleStatus = async (id) => {
//     await fetch(`${Api}customers/types/toggle.php`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ id }),
//     });
//     loadTypes();
//   };

//   const deleteType = async (id) => {
//     if (!window.confirm("Delete this type?")) return;

  
//     await fetch(`${Api}customers/types/delete.php`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ id }),
//     });
//     loadTypes();
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-8">
//       <div className="max-w-4xl mx-auto space-y-6">
//         <h1 className="text-2xl font-extrabold">Customer Type Management</h1>

//         {/* Add Type */}
//         <div className="bg-white p-4 rounded shadow border flex gap-3">
//           <input
//             value={typeName}
//             onChange={(e) => setTypeName(e.target.value)}
//             placeholder="Enter new type"
//             className="flex-1 border px-3 py-2 rounded"
//           />
//           <button
//             onClick={addType}
//             disabled={loading}
//             className="px-4 py-2 bg-indigo-600 text-white font-bold rounded"
//           >
//             Add
//           </button>
//         </div>

//         {/* Type List */}
//         <div className="bg-white rounded shadow border overflow-x-auto">
//           <table className="w-full text-sm border-collapse">
//             <thead className="bg-gray-100">
//               <tr>
//                 <th className="border px-3 py-2">#</th>
//                 <th className="border px-3 py-2">Type</th>
//                 <th className="border px-3 py-2">Status</th>
//                 <th className="border px-3 py-2">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {types.map((t, i) => (
//                 <tr key={t.id}>
//                   <td className="border px-3 py-2">{i + 1}</td>
//                   <td className="border px-3 py-2 font-bold capitalize">
//                     {t.type_name}
//                   </td>
//                   <td className="border px-3 py-2">
//                     <span
//                       className={`px-2 py-1 rounded-full text-xs font-bold ${
//                         t.status === "Active"
//                           ? "bg-green-100 text-green-800"
//                           : "bg-red-100 text-red-800"
//                       }`}
//                     >
//                       {t.status}
//                     </span>
//                   </td>
//                   <td className="border px-3 py-2 space-x-2">
//                     <button
//                       onClick={() => toggleStatus(t.id)}
//                       className="px-3 py-1 text-xs bg-amber-500 text-white rounded"
//                     >
//                       Toggle
//                     </button>
//                     <button
//                       onClick={() => deleteType(t.id)}
//                       className="px-3 py-1 text-xs bg-red-600 text-white rounded"
//                     >
//                       Delete
//                     </button>
//                   </td>
//                 </tr>
//               ))}

//               {types.length === 0 && (
//                 <tr>
//                   <td colSpan="4" className="text-center py-6 text-gray-400">
//                     No types found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </table>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TypeManagement;


import React, { useEffect, useState } from "react";
import { Api } from "../Api/Api";

const TypeManagement = () => {
  const [types, setTypes] = useState([]);
  const [typeName, setTypeName] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadTypes();
  }, []);

  const loadTypes = async () => {
    const res = await fetch(`${Api}customers/types/list.php`);
    const data = await res.json();
    setTypes(data.types || []);
  };

  const addType = async () => {
    if (!typeName.trim()) return alert("Enter type name");

    setLoading(true);
    const res = await fetch(`${Api}customers/types/add.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type_name: typeName }),
    });
    const data = await res.json();
    setLoading(false);

    if (data.status) {
      setTypeName("");
      loadTypes();
    } else {
      alert(data.message);
    }
  };

  const toggleStatus = async (id) => {
    await fetch(`${Api}customers/types/toggle.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
    loadTypes();
  };

  const deleteType = async (id) => {
    if (!window.confirm("Delete this type?")) return;

    await fetch(`${Api}customers/types/delete.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    });
    loadTypes();
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8">
      <div className="max-w-4xl mx-auto space-y-6">
        <h1 className="text-xl md:text-2xl font-extrabold text-gray-800">
          Customer Type Management
        </h1>

        {/* ✅ Add Type - Responsive Input Group */}
        <div className="bg-white p-4 rounded-xl shadow-sm border flex flex-col sm:flex-row gap-3">
          <input
            value={typeName}
            onChange={(e) => setTypeName(e.target.value)}
            placeholder="Enter new type (e.g. Premium)"
            className="flex-1 border border-gray-300 px-4 py-2 rounded-lg focus:ring-2 focus:ring-indigo-500 outline-none transition-all"
          />
          <button
            onClick={addType}
            disabled={loading}
            className="w-full sm:w-auto px-6 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-lg transition-colors disabled:bg-indigo-300"
          >
            {loading ? "..." : "Add Type"}
          </button>
        </div>

        {/* ✅ Type List - Responsive Table Container */}
        <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm text-left">
              <thead className="bg-gray-50 border-b">
                <tr>
                  <th className="px-4 py-3 font-semibold text-gray-600">#</th>
                  <th className="px-4 py-3 font-semibold text-gray-600">
                    Type Name
                  </th>
                  <th className="px-4 py-3 font-semibold text-gray-600">
                    Status
                  </th>
                  <th className="px-4 py-3 font-semibold text-gray-600 text-right">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {types.map((t, i) => (
                  <tr key={t.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-4 text-gray-500">{i + 1}</td>
                    <td className="px-4 py-4">
                      <span className="font-bold text-gray-700 capitalize">
                        {t.type_name}
                      </span>
                    </td>
                    <td className="px-4 py-4">
                      <span
                        className={`inline-flex px-2.5 py-0.5 rounded-full text-xs font-bold ${
                          t.status === "Active"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {t.status}
                      </span>
                    </td>
                    <td className="px-4 py-4 text-right">
                      <div className="flex justify-end gap-2">
                        <button
                          onClick={() => toggleStatus(t.id)}
                          className="px-3 py-1.5 text-xs font-semibold bg-amber-50 text-amber-700 border border-amber-200 rounded-md hover:bg-amber-100 transition-colors"
                        >
                          Toggle
                        </button>
                        <button
                          onClick={() => deleteType(t.id)}
                          className="px-3 py-1.5 text-xs font-semibold bg-red-50 text-red-700 border border-red-200 rounded-md hover:bg-red-100 transition-colors"
                        >
                          Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}

                {types.length === 0 && (
                  <tr>
                    <td colSpan="4" className="text-center py-10 text-gray-400">
                      No customer types found. Add one above.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TypeManagement;
